import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { DividendEventEdit, DividendUpdateRequest } from './types'
import { $params } from '../../../../features/router'
import { DividendEvent } from '../details/types'

export const dividendEventMounted = createEvent()
export const setDividendEvent = createEvent<DividendEvent>()

export const setDividendEventEdit = createEvent<DividendEventEdit>()

export const submitEditDividendEvent = createEvent<DividendEventEdit>()
export const $dividendEvent = restore(setDividendEvent, {
  dividendEventID: '',
  stage: 0,
  paymentDate: '',
  status: '',
  type: '',
  amount: '',
  annualDividends: '',
  feeTotal: '',
  fees: [
    {
      Value: '',
      Name: '',
      Type: '',
    },
  ],
  propertyId: '',
  name: '',
  tokenAmount: '',
  propertyPrice: '',
  investmentStrategy: {
    type: '',
    name: '',
  },
  stages: 0,
  updatedByUsername: '',
  createdAt: '',
  updatedAt: '',
  appreciationDividendInfo: {
    totalNetValue: '',
    finalPropertyPrice: '',
    appreciationFeeValue: '',
    initialPropertyPrice: '',
    appreciationFeePercent: '',
    finalPropertyAppreciation: '',
  },
})

export const $dividendEventEdit = restore(setDividendEventEdit, {
  amount: '0',
  paymentDate: '',
  status: 'created',
})
export const getDividendEvent = fx<void, DividendEvent>({
  method: 'GET',
  url: '/nova/dividend_event/',
})

export const updateDividendEvent = fx<DividendUpdateRequest, DividendEvent>({
  method: 'PUT',
  url: '/nova/dividend_event/',
})

const normalizePaymentDate = (paymentDate: string | number) => {
  if (typeof paymentDate === 'number') {
    return Number.isFinite(paymentDate) ? paymentDate : null
  }

  if (!paymentDate) {
    return null
  }

  const numericPaymentDate = Number(paymentDate)

  if (Number.isFinite(numericPaymentDate)) {
    return numericPaymentDate
  }

  const parsedPaymentDate = new Date(paymentDate).getTime()

  return Number.isFinite(parsedPaymentDate) ? parsedPaymentDate : null
}

sample({
  clock: dividendEventMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.dividendEventID
    }
    return {
      url: `/nova/dividend_event/${id}`,
    }
  },
  target: getDividendEvent,
})

sample({
  clock: [getDividendEvent.doneData, updateDividendEvent.doneData],
  fn: (doneData) => ({
    amount: doneData.body.amount,
    paymentDate: doneData.body.paymentDate,
    status:
      doneData.body.status == 'planned' ? 'created' : doneData.body.status,
  }),
  target: [setDividendEventEdit],
})

sample({
  clock: [getDividendEvent.doneData, updateDividendEvent.doneData],
  fn: (doneData) => doneData.body,
  target: [setDividendEvent],
})

sample({
  clock: submitEditDividendEvent,
  source: $params,
  fn: (params, dividentEventEdit) => {
    let id
    if (params) {
      id = params.dividendEventID
    }
    return {
      url: `/nova/dividend_event/${id}`,
      body: {
        ...dividentEventEdit,
        amount: Number(dividentEventEdit.amount),
        paymentDate: normalizePaymentDate(dividentEventEdit.paymentDate),
      },
    }
  },
  target: updateDividendEvent,
})
